// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__Qj43x","submit":"styles_submit__7kd5J"};